export default () => ({
    loading: false,
    toast: {},
})